import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { MediaTypeEnum, getSocialMediaTypes, getSocialMediaPlatformTypes, mediaTypeColorKeyMap } from '@Common/Basic/enums/media-type.enum';
import { UserAppPreferenceChartColors } from '../../../../../Core/Users/models/user-app-preferences-chart-colors.model';
import { MonitorConfigService } from '../../../../MonitorShared/services/monitor-config.service';
import { ChartColorPickerFieldModel } from '../../../models/chart-color-picker-field.model';
import { MediaTypeCollectionTypesEnum, MediaTypeColorPickerWrapperFieldModel } from '../../../models/media-type-color-picker-wrapper-field.model';
import { ChartColorPickerFieldComponent } from '../ChartColorPickerField/chart-color-picker-field.component';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';


@Component({
    selector: 'agpr-media-type-color-picker-wrapper-field',
    templateUrl: './media-type-color-picker-wrapper-field.component.html',
    styleUrls: ['./media-type-color-picker-wrapper-field.component.scss'],
    standalone: false
})
export class MediaTypeColorPickerWrapperFieldComponent extends AbstractFormFieldComponent implements OnInit, OnDestroy {
    @Input() declare field: MediaTypeColorPickerWrapperFieldModel;
    colorFieldModels: ChartColorPickerFieldModel[] = [];

    protected subscriptions: Subscription[] = [];

    constructor(
        protected monitorConfigService: MonitorConfigService
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.push(
            this.monitorConfigService.getAvailableMediaTypes().subscribe(mediaTypes => {
                let colorSettings: [string, MediaTypeEnum][];
                const allMediaTypes = Object.entries(MediaTypeEnum);

                switch (this.field.mediaTypeCollectionType) {
                    case MediaTypeCollectionTypesEnum.CORE_SOCIAL_MEDIA_TYPE_ONLY:
                        const socialMediaTypes: MediaTypeEnum[] = getSocialMediaTypes();
                        colorSettings = allMediaTypes
                            .filter(([k, v]) => socialMediaTypes.includes(v))
                            .map(([k, v]) => [mediaTypeColorKeyMap.get(v) ?? k, v]);
                        break;
                    case MediaTypeCollectionTypesEnum.SOCIAL_MEDIA_TYPES_ONLY:
                        const socialMediaPlatformTypes = getSocialMediaPlatformTypes();
                        colorSettings = allMediaTypes
                            .filter(([k, v]) => socialMediaPlatformTypes.includes(v))
                            .map(([k, v]) => [mediaTypeColorKeyMap.get(v) ?? k, v]);
                        break;
                    case MediaTypeCollectionTypesEnum.ALL:
                        colorSettings = allMediaTypes.map(([k, v]) => [mediaTypeColorKeyMap.get(v) ?? k, v]);
                        break;
                }

                if (!mediaTypes.includes(MediaTypeEnum.TIKTOK)) {
                    colorSettings = colorSettings.filter(([k, v]) => v !== MediaTypeEnum.TIKTOK);
                }

                this.colorFieldModels = this.mapObjectEntriesToFieldModels(colorSettings);
            })
        );
    }

    emitChanges(event) {
        this.changes.emit(this.block.displayElement.styles.colorMap);
    }

    protected mapObjectEntriesToFieldModels(entries: [string, MediaTypeEnum][]): ChartColorPickerFieldModel[] {
        return entries.map(([key, mediaType]) => {
            return new ChartColorPickerFieldModel(
                ChartColorPickerFieldComponent,
                {
                    property: `styles.colorMap.${mediaType}`,
                    key: mediaType,
                    label: `MediaType.${mediaType}`,
                    showRecentColors: true
                },
                { colorType: 'mediaTypeColors', typeProperty: key as keyof UserAppPreferenceChartColors['mediaTypeColors'] },
            );
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
